import MuiButton from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

const Button = (props) => {
  const {
    name,
    onClick,
    color = "primary",
    variant = "outlined",
    disabled,
    showLoading,
    sx,
    startIcon,
  } = props;

  return (
    <MuiButton
      size="medium"
      sx={sx}
      variant={variant}
      onClick={onClick}
      color={color}
      disabled={disabled}
      startIcon={showLoading ? <CircularProgress color="inherit" size={16} /> : startIcon || null}
    >
      {name}
    </MuiButton>
  );
};

export default Button;
